import { requestJson } from "../api/apiClient";

const ADMIN_BASE = "/api/admin/automotive";

export function fetchAdminDashboard(range = "last_30_days") {
  const qs = new URLSearchParams({ range }).toString();
  return requestJson(`${ADMIN_BASE}/dashboard?${qs}`);
}

export function trackAdminDashboardAnalytics(eventType, metadata = {}) {
  return requestJson(`${ADMIN_BASE}/dashboard/events`, {
    method: "POST",
    body: JSON.stringify({ eventType, ...metadata }),
  }).catch(() => {});
}
